import React from "react";
import SummaryCard from "./SummaryCard";
import { getComplianceNameById } from "./summaryHelpers";
import { FilledMoundSystemInspectionInput } from "../FilledMoundSystemForm.types";
import { ComplianceData } from "../SetBacksInspectionForm.types";

type Props = {
    data?: FilledMoundSystemInspectionInput;
    complianceData?: ComplianceData[];
};

const FilledMoundSystemReadOnly: React.FC<Props> = ({ data, complianceData }) => {
    if (!data) return null;
    return (
        <SummaryCard
            title={
                <>
                    <svg className="me-2" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 20h18"/><path d="M8 16l4-8 4 8"/></svg>
                    Filled/Mound Installation
                </>
            }
        >
            {/* Order: Drainfield Cover, Shoulders, Slopes, Stabilization (Material), Owner/Agent Responsible */}
            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.drainfieldCoverComplianceId)}</label>
                </div>
                <div className="col col-md-4">
                    <label> {"Drainfield Cover"}</label>
                </div>
            </div>
            {(data as any)?.drainfieldCoverCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <label>{data?.drainfieldCoverComment}</label>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.shoulderComplianceId)}</label>
                </div>
                <div className="col col-md-4">
                    <label> {"Shoulders"}</label>
                </div>
            </div>
            {(data as any)?.shoulderCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <label>{data?.shoulderComment}</label>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.slopeComplianceId)}</label>
                </div>
                <div className="col col-md-4">
                    <label> {"Slopes"}</label>
                </div>
            </div>
            {(data as any)?.slopeCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <label>{data?.slopeComment}</label>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.stablizationComplianceId)}</label>
                </div>
                <div className="col col-md-4">
                    <label> Stabilization</label>
                    {(data as any)?.stablization?.stabizationValue && (
                        <span className="print-value">{` (${(data as any)?.stablization?.stabizationValue})`}</span>
                    )}
                </div>
            </div>
            {(data as any)?.stablizationCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <label>{data?.stablizationComment}</label>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>Owner/Agent Responsible</label>
                </div>
                <div className="col col-md-4">
                    {(data as any)?.ownerAgentResponsible !== undefined && (data as any)?.ownerAgentResponsible !== null && (
                        <span className="print-value">{` (${(data as any)?.ownerAgentResponsible ? "Yes" : "No"})`}</span>
                    )}
                </div>
            </div>
        </SummaryCard>
    );
};

export default FilledMoundSystemReadOnly;


